import React from 'react';
import PropTypes from 'prop-types';
import SanitizedHTML from 'react-sanitized-html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircle,
  faPhone,
  faCalendarAlt,
  faEnvelope
} from '@fortawesome/pro-solid-svg-icons';

export default class RecentActivities extends React.Component {
  static propTypes = {
    activities: PropTypes.arrayOf(PropTypes.shape({
      body: PropTypes.string,
      calendarImport: PropTypes.bool,
      completedAt: PropTypes.string.isRequired,
      hasCrmEmail: PropTypes.bool,
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })).isRequired
  };

  render() {
    const recentActivities = [];
    this.props.activities.slice(0, 3).forEach((activity) => {
      if (activity) {
        recentActivities.push(this.renderActivity(activity));
      }
    });

    return (
      <div>
        {this.props.activities.length > 0 &&
          <div>
            <div className="preview-subtitle" > Recent Activity </div>
            <div className="recent-activity-block">
              <div className="solid-line"></div>
              {recentActivities}
            </div>
          </div>
        }
      </div>
    );
  }

  renderActivity(activity) {
    let icon = "", title = "", iconBackground = "";

    switch (activity.type) {
    case 'call':
      icon = faPhone;
      title = activity.title;
      iconBackground = "call-icon";
      break;
    case 'meeting':
      icon = faCalendarAlt;
      title = "Meeting @ " + activity.title;
      iconBackground = "meeting-icon";
      break;
    default:
      icon = faEnvelope;
      title = activity.title;
      iconBackground = "email-icon";
      break;
    }

    return (
      <div className="recent-activities" key={activity.id}>
        <div className="fa-2x  col-md-1 pl-0 right-buffer-md">
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon className={iconBackground} icon={faCircle}/>
            <FontAwesomeIcon
              className="inner-icon"
              icon={icon}
              transform="shrink-8"
            />
          </span>
        </div>
        <div className="col-md-7 pl-0 pr-0">
          <div className="preview-title"> {title} </div>
          {this.renderActivityBody(activity)}
        </div>
        <div className="col-md-4 completed-at-text">
          <div className="text-muted"> {activity.completedAt} </div>
        </div>
      </div>
    );
  }

  renderActivityBody(activity) {
    if (activity.hasCrmEmail || activity.calendarImport) {
      return <SanitizedHTML className="fade-lock" html={activity.body} />;
    }

    return <div className="preview-text text-muted"> {activity.body} </div>;
  }
}
